<template>
    <ul class="list is-unstyled">
      <template v-for="(step, index) in steps" >
      <li class="list-item" :key="step">
        <div class="tag is-dark step-number" :class="{ 'is-primary': index === current } ">
          {{ index + 1 }}
        </div>
        <div v-show="index === current" class="step-name">
          {{ step }}
        </div>
      </li>
      <li class="connector" :key="index"> </li>
      </template>
    </ul>
</template>

<script>
export default {
  name: 'ProgressTrackerBar',

  props: {
    steps: {
      type: Array,
      required: true
    },
    current: {
      type: Number,
      default: () => 0
    }
  },

  data() {
    return {
      activeIndex: 0
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.list.is-unstyled {
  background: none;
  box-shadow: none;

  .list-item {
    border-bottom: none;
  }
}

.list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-number {
  border-radius: 50%;
  font-size: 1rem;
  margin-bottom: 8px;
}

.step-name {
  font-size: 0.75rem;
  text-transform: capitalize;
  font-weight: bolder;
}

.connector {
  background-color: #ff1014;
  flex: 1;
  height: 1px;
  margin: 0 15px;
}

.connector:last-child {
  display: none;
}
</style>
